import { Link } from 'react-router-dom';
import config from './HomePageShortcuts.config.json';
import PropTypes from 'prop-types';

function HomePageShortcuts({ pathPrefix }) {
  const shortcuts = config.sort(
    ({ componentName: componentNameA }, { componentName: componentNameB }) =>
      componentNameA.toLowerCase() < componentNameB.toLowerCase() ? -1 : 1,
  );

  return (
    <ul>
      {shortcuts.map(({ componentName, searchParamConfigs }) => {
        const pathname = `${pathPrefix}/${componentName}`;
        return (
          <li key={componentName} style={{ fontSize: '30px' }}>
            <Link to={pathname}>{componentName}</Link>
            {Boolean(searchParamConfigs.length) && (
              <ul>
                {searchParamConfigs.map(
                  ({ title, templateParams, mockParams }) => {
                    return (
                      <li key={title}>
                        <Link
                          to={`${pathname}?${new URLSearchParams({
                            ...templateParams,
                            ...mockParams,
                          }).toString()}`}
                        >
                          {title}
                        </Link>
                      </li>
                    );
                  },
                )}
              </ul>
            )}
          </li>
        );
      })}
    </ul>
  );
}

HomePageShortcuts.propTypes = {
  pathPrefix: PropTypes.string.isRequired,
};

export default HomePageShortcuts;
